import { useState } from 'react';
import { Button, Box, Divider, Typography, styled } from '@mui/material';
import DynamicSearchField from 'components/new/DynamicSearchField';
import { Column, Row } from 'further-ui/components/Layout';
import useSearchInvestors from '../useSearchInvestors';
import InvestorSearchResult from './InvestorSearchResult';
import InvestorDetails from './InvestorDetails';
import Header from '../Header';

const Line = styled(Box)({
  width: '100%',
});

type Props = {
  selectedInvestorId: string | null;
  onInvestorSelect: (investorId: string) => void;
  onShowNewInvestorForm: () => void;
  onClose: () => void;
  onSuccess?: (
    vehicleApplicationId: string,
    addWithCommitment: boolean,
  ) => void;
  vehicle: {
    _id: string;
    vehicleName: string;
  };
};

const InvestorSearch: React.FC<Props> = ({
  selectedInvestorId,
  onInvestorSelect,
  onShowNewInvestorForm,
  onClose,
  onSuccess,
  vehicle,
}) => {
  const [query, setQuery] = useState('');

  const { investors, isFetching } = useSearchInvestors(query, vehicle._id);

  const options = investors.map((investor) => ({
    value: investor.id,
    label: <InvestorSearchResult {...investor} />,
  }));

  const selectedInvestor = selectedInvestorId
    ? investors.find((investor) => investor.id === selectedInvestorId)
    : undefined;

  if (selectedInvestor) {
    return (
      <>
        <Header
          selectedInvestor={selectedInvestor}
          vehicleName={vehicle.vehicleName}
        />
        <InvestorDetails
          vehicleId={vehicle._id}
          onClose={onClose}
          onSuccess={onSuccess}
          investor={selectedInvestor}
        />
      </>
    );
  }

  return (
    <>
      <Header
        selectedInvestor={selectedInvestor}
        vehicleName={vehicle.vehicleName}
      />
      <Column spacing="lg" fullWidth>
        <DynamicSearchField
          placeholder="Search for an investor"
          onSearch={setQuery}
          options={options}
          isLoading={isFetching}
          onOptionSelect={onInvestorSelect}
          noResultsMessage={`No existing investor named "${query}".`}
        />
        <Row fullWidth centered spacing="xs">
          <Line>
            <Divider />
          </Line>
          <Typography variant="h6">or</Typography>
          <Line>
            <Divider />
          </Line>
        </Row>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          onClick={onShowNewInvestorForm}
        >
          Add new investor
        </Button>
      </Column>
    </>
  );
};

export default InvestorSearch;
